import React from 'react';

export interface SalaryPayslipBreakdownProps {
  grossAmount?: number;
  taxLines?: { label: string; amount: number }[];
  totalTax?: number;
  netAmount: number;
  /** default: 테이블 하단용 / compact: 모바일·사이드바 */
  variant?: 'default' | 'compact';
  /** false면 상단「급여 명세서」제목 숨김(목록에서 섹션 제목만 쓸 때) */
  showTitle?: boolean;
}

const SalaryPayslipBreakdown: React.FC<SalaryPayslipBreakdownProps> = ({
  grossAmount,
  taxLines,
  totalTax,
  netAmount,
  variant = 'default',
  showTitle = true,
}) => {
  const gross = grossAmount ?? netAmount;
  const lines = taxLines || [];
  const deducted =
    totalTax ?? lines.reduce((s, x) => s + (Number(x.amount) || 0), 0);

  const isCompact = variant === 'compact';
  const fs = isCompact ? '0.75rem' : '13px';
  const fsStrong = isCompact ? '0.8125rem' : '14px';
  const titleFs = isCompact ? '0.8125rem' : '13px';
  const font = 'Pretendard, sans-serif';

  return (
    <div
      style={{
        padding: isCompact ? '12px 14px' : '12px 24px 16px',
        background: 'var(--Color-background-main, #F4F6FA)',
        borderRadius: isCompact ? '8px' : '0',
        border: isCompact ? '1px solid var(--Color-line-normal, #F0F0F0)' : 'none',
      }}
    >
      {showTitle && (
        <div
          style={{
            fontSize: titleFs,
            fontWeight: 600,
            marginBottom: isCompact ? '8px' : '10px',
            color: 'var(--Color-text-strong, #0D0D0D)',
            fontFamily: font,
          }}
        >
          급여 명세서
        </div>
      )}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: fs,
          marginBottom: isCompact ? '4px' : '6px',
          fontFamily: font,
          color: 'var(--Color-text-normal)',
        }}
      >
        <span>총 급여(세전)</span>
        <span>{gross.toLocaleString('ko-KR')} P</span>
      </div>
      {lines.map((t, ti) => (
        <div
          key={`${t.label}-${ti}`}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: fs,
            marginBottom: isCompact ? '2px' : '4px',
            fontFamily: font,
            color: 'var(--Color-text-normal)',
          }}
        >
          <span>└ {t.label}</span>
          <span>−{t.amount.toLocaleString('ko-KR')} P</span>
        </div>
      ))}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: fs,
          marginTop: isCompact ? '6px' : '8px',
          paddingTop: isCompact ? '6px' : '8px',
          borderTop: '1px solid var(--Color-line-normal, #F0F0F0)',
          fontFamily: font,
          color: 'var(--Color-text-normal)',
        }}
      >
        <span>공제 합계</span>
        <span>−{deducted.toLocaleString('ko-KR')} P</span>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: fsStrong,
          marginTop: isCompact ? '6px' : '8px',
          fontWeight: 600,
          fontFamily: font,
          color: 'var(--Color-text-strong)',
        }}
      >
        <span>실수령(지급)</span>
        <span>{netAmount.toLocaleString('ko-KR')} P</span>
      </div>
    </div>
  );
};

export default SalaryPayslipBreakdown;
